
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
 import { useCallback } from "react";

export function useSleepLookupData() {
  const { toast } = useToast();

  const loadLookupData = useCallback(async (
    setLocations: (data: any[]) => void,
    setEnvironments: (data: any[]) => void,
    setOnsetMethods: (data: any[]) => void,
    setSounds: (data: any[]) => void,
    setSoundLevels: (data: any[]) => void,
    setRestfulnessRatings: (data: any[]) => void
  ) => {
    try {
      const [
        { data: locationData },
        { data: environmentData },
        { data: onsetData },
        { data: soundData },
        { data: soundLevelData },
        { data: restfulnessData }
      ] = await Promise.all([
        supabase.from('nap_location').select('id, description').order('description'),
        supabase.from('environments').select('id, description').order('description'),
        supabase.from('onset_methods').select('id, method').order('method'),
        supabase.from('sleep_sounds').select('id, name').order('name'),
        supabase.from('sound_levels').select('id, level').order('level'),
        supabase.from('restfulness').select('id, rating').order('rating')
      ]);

      if (locationData) setLocations(locationData);
      if (environmentData) setEnvironments(environmentData);
      if (onsetData) setOnsetMethods(onsetData.map(item => ({ id: item.id, description: item.method })));
      if (soundData) setSounds(soundData);
      if (soundLevelData) setSoundLevels(soundLevelData);
      if (restfulnessData) setRestfulnessRatings(restfulnessData.map(item => ({ id: item.id, description: item.rating })));
    } catch (err) {
      console.error('Error loading lookup data:', err);
      toast({
        variant: "destructive",
        title: "Error",
        description: "Failed to load sleep tracking options"
      });
    }
  }, [toast]);

  return { loadLookupData };
}
